export const PREV_QNT = 5;